<template>
  <a-layout-content>
    <a-form layout="inline">
      <a-form-item label="分组">
        <a-select
          v-model="input.drp_role"
          style="width: 100px"
          default-value="0"
          @change="query()"
        >
          <a-select-option value="0">--- 全部 ---</a-select-option>
          <a-select-option
            v-for="item in selectOption.Rolelist"
            :key="item.Role"
          >
            {{ item.RoleName }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>

    <div class="body-nest">
      <a-table
        bordered
        row-key="RoleID"
        size="middle"
        :columns="columns"
        :data-source="datarow"
        :pagination="pagination"
        @change="changepage"
      >
        <template slot="title">
          <span></span>
          <a-row :gutter="24">
            <a-col style="float: right" v-if="role13">
              <a-button type="primary" @click="addsetting()">新增权限</a-button>
              <a-button type="primary" @click="menuShow()">选单排序</a-button>
            </a-col>
          </a-row>
        </template>

        <template slot="operation" slot-scope="text, record">
          <span>
            <a-space :size="20">
              <a-tooltip placement="left" title="权限设定" v-if="role13">
                <a-icon
                  type="edit"
                  style="font-size: 22px"
                  @click="editsetting(record)"
                ></a-icon>
              </a-tooltip>
              <a-tooltip placement="right" title="删除权限" v-if="role14">
                <a-icon
                  type="delete"
                  style="font-size: 22px"
                  @click="deletesetting(record)"
                ></a-icon>
              </a-tooltip>
            </a-space>
          </span>
        </template>
      </a-table>
    </div>

    <!-------------------------------------------------------弹窗部份--------------------------------------------------------->
    <a-modal
      v-model="visible"
      title="新增/编辑权限设定"
      width="60%"
      ok-text="储存"
      cancel-text="取消"
      @ok="onEditSubmit"
      layout="inline"
    >
      <a-list style="margin-left: 40px">
        <!--<a-button type="primary" @click="chkall(1)">全选</a-button>
        <a-button type="primary" @click="chkall(2)" style="margin-left: 15px">反选</a-button>-->

        <template v-for="(item, index) in chklist">
          <div
            class="clearline"
            :key="'divb_' + item.Index"
            v-if="chkclearline(item)"
          />
          <div
            :key="'div_' + item.Index"
            v-if="chkclearline(item)"
            style="margin-bottom: 5px"
          >
            <span
              v-if="chkshow(item)"
              style="
                font-size: 16px;
                color: gray;
                font-weight: bold;
                border: 2px solid;
                padding: 3px;
              "
              >{{ item.PName }} ：
            </span>
          </div>
          <a-checkbox
            v-model="item.State"
            :key="item.Index"
            :lable="index"
          >
            <span v-if="item.Level == 1" style="color: red">
              {{ item.Name }}
            </span>
            <span v-else> {{ item.Name }} </span>
          </a-checkbox>
        </template>
        <div class="clearline" />
        <a-form-model
          ref="RoleForm"
          :model="form"
          :rules="rules"
          layout="inline"
        >
          <a-form-model-item ref="RoleName" label="权限名称" prop="RoleName">
            <a-input
              placeholder="输入权限名称"
              v-model="form.RoleName"
              type="text"
              autocomplete="off"
            />
          </a-form-model-item>
          <a-form-model-item label="备注">
            <a-input
              placeholder="输入备注"
              v-model="form.RoleMemo"
              type="text"
              autocomplete="off"
            />
          </a-form-model-item>
        </a-form-model>
      </a-list>
    </a-modal>
    <a-modal
      v-model="menuModal"
      title="选单排序"
      width="60%"
      ok-text="储存"
      cancel-text="取消"
      @ok="onMenuSubmit"
      layout="inline"
    >
      <a-table
        bordered
        row-key="Index"
        size="middle"
        :columns="menuColumns"
        :data-source="menuData"
        :pagination="false"
        :customRow="customRow"
      >
      </a-table>
    </a-modal>
    <!-------------------------------------------------------弹窗结束--------------------------------------------------------->
  </a-layout-content>
</template>
<script>
let datarow = [];

export default {
  data() {
    return {
      role13: false,
      role14: false,
      Pname: "",
      Pname2: "",
      indeterminate: true,

      //------table --------
      columns: IninTable(),
      datarow,
      pagination: {
        total: 0,
        pageindex: 1,
        pagesize: 10,
      },
      //--------------------
      input: {
        drp_role: "0",
      },
      selectOption: {
        Rolelist: [],
      },
      form: {
        RoleName: "",
        RoleMemo: "",
      },
      rules: {
        RoleName: [
          {
            required: true,
            trigger: "blur",
            validator: this.validateEmpty,
          },
        ],
      },
      visible: false,
      chklist: [],
      maxRole: 0,
      menuModal: false,
      menuColumns: [
        {
          title: "选单名称",
          dataIndex: "Name",
        },
      ],
      menuData: [], // 拖动排序
      sourceObj: {}, //源数据
      targetObj: {}, //目标数据
    };
  },
  methods: {
    query() {
      let params = {
        Role: this.input.drp_role,
        pageindex: this.pagination.pageindex,
        pagesize: this.pagination.pagesize,
      };

      this.axios.post("/role/getrolelist", params).then((res) => {
        this.datarow = res.data;
        this.selectOption.Rolelist = res.extend;
        this.pagination.total = res.total;
      });
    },
    editsetting(record) {
      this.visible = true;
      this.form.RoleName = record.RoleName;
      this.form.RoleMemo = record.RoleMemo;
      this.getsetting(record.Role);
    },
    deletesetting(record) {
      let params = {
        Role: record.Role,
      };

      this.axios.post("/role/deleteroleset", params).then((res) => {
        if (res.data) {
          this.$message.success("删除成功!");
          this.query();
        } else {
          this.$message.error("删除失败!");
        }
      });
    },
    addsetting() {
      this.visible = true;
      this.form.RoleName = "";
      this.form.RoleMemo = "";
      this.getsetting(0);
    },
    getsetting(Role) {
      this.chklist = [];
      let params = {
        Role: Role,
      };

      this.axios.post("/role/getroleset", params).then((res) => {
        if (Role == 0) {
          this.maxRole = res.total + 1;
        } else {
          this.maxRole = Role;
        }
        for (let i = 0; i < res.data.length; i++) {
          this.chklist.push({
            Role: this.maxRole,
            Index: res.data[i].Index,
            Name: res.data[i].Name,
            TypeSort: res.data[i].TypeSort,
            State: res.data[i].State,
            Level: res.data[i].Level,
            PName: res.data[i].PName,
          });
        }
      });
    },
    changepage(e) {
      this.pagination.pageindex = e.current;
      this.pagination.pagesize = e.pageSize;
      this.query();
    },
    onEditSubmit() {
      this.$refs.RoleForm.validate((valid) => {
        if (valid) {
          let params = {
            RoleName: this.form.RoleName,
            RoleMemo: this.form.RoleMemo,
            SysRoleSet: this.chklist,
          };

          this.axios.post("/role/saveroleset", params).then((res) => {
            if (res.data) {
              this.$message.success("保存成功!");
              this.query();
              this.visible = false;
            } else {
              this.$message.error("保存失败!");
            }
          });
        } else {
          return false;
        }
      });
    },
    chkclearline(item) {
      let resultbool = false;
      if (item.Level === 1) {
        resultbool = true;
      }
      return resultbool;
    },
    chkshow(item) {
      this.PName = item.PName;
      let result = false;
      if (this.PName2 !== this.PName && item.PName != "") {
        result = true;
      }
      this.PName2 = item.PName;

      return result;
    },
    //chkall(checked) {
    //},

    //显示选单排序
    menuShow() {
      this.menuModal = true;
      this.axios.post("/role/getmenusort", {}).then((res) => {
        var dd = [];
        var i = 0;
        res.data.forEach((element) => {
          if (element.Parents === 0) {
            element.children = [];
            var Sort = dd.length + 1;
            dd.push({
              Index: element.Index,
              Name: element.Name,
              TypeSort: Sort,
              Parents: element.Parents,
              children: [],
            });
          } else if (element.Parents !== 0) {
            dd.forEach((ele) => {
              if (ele.Index === element.Parents) {
                var Sort = ele.children.length + 1;
                ele.children.push({
                  Index: element.Index,
                  Name: element.Name,
                  Parents: element.Parents,
                  TypeSort: Sort,
                });
                return;
              }
            });
          }
        });
        this.menuData = dd;
      });
    },
    //提交选单排序
    onMenuSubmit() {
      let list = [];
      this.menuData.forEach((element) => {
        list.push({ Index: element.Index, TypeSort: element.TypeSort });
        if (element.children.length > 0) {
          element.children.forEach((ele) => {
            list.push({ Index: ele.Index, TypeSort: ele.TypeSort });
          });
        }
      });
      this.axios
        .post("/role/savemenusort", {
          list: list,
        })
        .then((res) => {
          if (res.data) {
            this.$message.success("保存成功");
          }
        });
    },
    customRow(record, index) {
      return {
        // FIXME: draggable： true 不生效还不晓得是什么原因，先使用鼠标移入事件设置目标行的draggable属性
        props: {
          // draggable: 'true'
        },
        style: {
          cursor: "pointer",
        },
        on: {
          // 鼠标移入
          mouseenter: (event) => {
            // 兼容IE
            var ev = event || window.event;
            ev.target.draggable = true;
          },
          // 开始拖拽
          dragstart: (event) => {
            // 兼容IE
            var ev = event || window.event;
            // 阻止冒泡
            ev.stopPropagation();
            // 得到源目标数据
            this.sourceObj = { ...record };
            //console.log(record);
          },
          // 拖动元素经过的元素
          dragover: (event) => {
            // 兼容 IE
            var ev = event || window.event;
            // 阻止默认行为
            ev.preventDefault();
          },
          // 鼠标松开
          drop: (event) => {
            // 兼容IE
            var ev = event || window.event;
            // 阻止冒泡
            ev.stopPropagation();
            // 得到目标数据
            this.targetObj = { ...record };
            //进行调整
            let boo = false;
            //保证同一目录下
            if (this.targetObj.Parents === 0 && this.sourceObj.Parents === 0) {
              let newData = [];
              let sort = 0;
              this.menuData.forEach((element) => {
                //添加源到目标数据数据
                if (element.Index === this.targetObj.Index) {
                  sort++;
                  newData.push({
                    Index: this.sourceObj.Index,
                    Name: this.sourceObj.Name,
                    TypeSort: sort,
                    Parents: this.sourceObj.Parents,
                    children: this.sourceObj.children,
                  });
                }
                //移除源数据
                if (element.Index !== this.sourceObj.Index) {
                  sort++;
                  newData.push({
                    Index: element.Index,
                    Name: element.Name,
                    TypeSort: sort,
                    Parents: element.Parents,
                    children: element.children,
                  });
                }
              });
              this.menuData = newData;
            } else if (
              this.targetObj.Parents === this.sourceObj.Parents &&
              this.targetObj.Index !== this.sourceObj.Index
            ) {
              this.menuData.forEach((element) => {
                if (element.Index === this.targetObj.Parents) {
                  let newChildren = [];
                  let sort = 0;
                  element.children.forEach((ele) => {
                    //添加源到目标数据数据
                    if (ele.Index === this.targetObj.Index) {
                      sort++;
                      newChildren.push({
                        Index: this.sourceObj.Index,
                        Name: this.sourceObj.Name,
                        TypeSort: sort,
                        Parents: this.sourceObj.Parents,
                        children: this.sourceObj.children,
                      });
                    }
                    //移除源数据
                    if (ele.Index !== this.sourceObj.Index) {
                      sort++;
                      newChildren.push({
                        Index: ele.Index,
                        Name: ele.Name,
                        TypeSort: sort,
                        Parents: ele.Parents,
                        children: ele.children,
                      });
                    }
                  });
                  element.children = newChildren;
                  return;
                }
              });
            } else {
              this.$message.success("位置移动指能在同一子目录下!");
            }
          },
        },
      };
    },
  },
  created() {
    this.query();
    this.getsetting(0);
    //获取权限
    const array = JSON.parse(sessionStorage.RoleID);
    const roleID = [13, 14];
    var isRole = roleID.filter(function (item) {
      return array.indexOf(item) != -1;
    });
    //功能权限获取
    isRole.forEach((element) => {
      this["role" + element] = true;
    });
  },
};

const IninTable = function IninTable() {
  var header = [];
  header.push({ title: "权限名称", align: "center", dataIndex: "RoleName" });
  header.push({ title: "备注", align: "center", dataIndex: "RoleMemo" });
  header.push({ title: "修改时间", align: "center", dataIndex: "Ldt" });
  header.push({ title: "修改人", align: "center", dataIndex: "Editor" });
  header.push({
    title: "操作",
    align: "center",
    dataIndex: "operation",
    ellipsis: true,
    scopedSlots: { customRender: "operation" },
    width: 150,
  });
  return header;
};
</script>

<style>
.clearline {
  border-top: solid #acc0d8 1px;
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/adminmanage/authority.vue